const offici = {
  namespaced: true,

  state: () => ({
    // === 新需求：售后服务单表单数据 ===
    serviceForm: {
      name: "",
      phone: "",
      email: "",
      company: "",
      orderType: "",
      deviceModel: "",
      otherModel: "",
      hasSerial: "yes",
      serialItems: [{ serialNo: "", faultDesc: "", attachments: [] }],
      noSerialDesc: "",
      noSerialAttachments: [],
      remark: "",
    },

    // 回寄地址（保留原有地址管理功能）
    address: {},
  }),

  getters: {},

  mutations: {
    // 保存表单数据（用于草稿）
    setServiceForm(state, payload) {
      state.serviceForm = { ...state.serviceForm, ...payload };
    },
    // 选择的地址
    setAddress(state, payload) {
      state.address = payload;
    },
    // 提交成功后清空
    clearServiceForm(state) {
      state.serviceForm = {
        name: "",
        phone: "",
        email: "",
        company: "",
        orderType: "",
        deviceModel: "",
        otherModel: "",
        hasSerial: "yes",
        serialItems: [{ serialNo: "", faultDesc: "", attachments: [] }],
        noSerialDesc: "",
        noSerialAttachments: [],
        remark: "",
      };
      state.address = {};
    },
  },
  actions: {},
};

export default offici;
